module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABNklEQVR4AeySsU4CQRiE/92NtYU+hAmF1b2LhYlHYcXzWFFAooXvcpUFia+hdgYW5yMYbrk7biGhILkNE3b/f+af3QFvZ16DQW/AQ0SnRVTOvu9Ar3pLgAu2x+Sr8RtADGH9GkJ8L9++ioTdcoADN0iDdp/SMDD7FWd9ZebufbSXp/nPyDoWPTgmrhkatJashsF8fPvpvXt2ZpVQBB9n3DJR6UCNHhyhQoNWreTTMKA7fbyuXFyOEQpFiC4x2QxXjZ6w4aJBu49WA0jT8mbhvE00YKHnj4iCSAB7avTgwEXThk4DyNxKA3YvUVz1WOjBgduFgwaIGFCPS7cuhIOxoPtHrwFEItBtJ4rlA7CnRq8PWQYM4SWr1fIBsKeWg2wDhvE3BOxzcZRB7tA6bzCop9G6v/yI/gAAAP//RYHRlwAAAAZJREFUAwAVdn4xYbuMYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icon-arrow-down.png
// module id = 74/F
// module chunks = 1